export const isAuthenticated = () => {
  const accessToken = localStorage.getItem('@AutoCenter: accessToken');
  const refreshToken = localStorage.getItem('@AutoCenter: refreshToken');
  const user = localStorage.getItem('@AutoCenter: user');

  const response = !!(accessToken && user && refreshToken);

  return response;
};
